import {
  IDENTITY_REGISTER_ATTEMPT,
  IDENTITY_REGISTER_FAILURE,
  IDENTITY_REGISTER_SUCCESS,
  IDENTITY_SUBSCRIBE_ATTEMPT,
  IDENTITY_SUBSCRIBE_FAILURE,
  IDENTITY_SUBSCRIBE_SUCCESS,  
  CLEAR_SIGNUP_STATE,
  CLEAR_STATE,
} from './actionTypes';

export const identityRegisterAttempt = (data) => ({
  type: IDENTITY_REGISTER_ATTEMPT,
  data,
});

export const identityRegisterSuccess = (registerSuccess) => ({
  type: IDENTITY_REGISTER_SUCCESS,
  registerSuccess,
});

export const identityRegisterFailure = (errorCode) => ({
  type: IDENTITY_REGISTER_FAILURE,
  errorCode,
});

export const identitySubscribeAttempt = () => ({
  type: IDENTITY_SUBSCRIBE_ATTEMPT
});

export const identitySubscribeSuccess = (subscribeSuccess) => ({
  type: IDENTITY_SUBSCRIBE_SUCCESS,
  subscribeSuccess,
});

export const identitySubscribeFailure = (errorCode) => ({
  type: IDENTITY_SUBSCRIBE_FAILURE,
  errorCode,
});
export const clearSignup = () => ({
  type: CLEAR_SIGNUP_STATE,
});

export const clearState = () => ({
  type: CLEAR_STATE,
});
